import React from "react"
import BannerHeader from "../banner-header/banner-header"
import OutOfTheBox from "../../atoms/out-of-the-box/out-of-the-box"
import forma1 from "../../../assets/images/home/forma1.png"

import "./modal-capacidades.scss"

const ModalCapacidades = (props) => {

    const { children, informationFilter, isMobile, setOpenModalAgentes, setOpenModalLogros } = props

    return (
        <div className="f-modalCapacidades">
            <BannerHeader bannerInformation={informationFilter} isMobile={isMobile} />
            <div className="f-modalCapacidades-content">
                <button className="f-modalCapacidades-content__close"
                    onClick={() => {
                        if (setOpenModalAgentes) {
                            setOpenModalAgentes(false)
                        } else if (setOpenModalLogros) {
                            setOpenModalLogros(false)
                        }
                    }}
                >
                    <i className="f-modalCapacidades-content__close-icon" />
                </button>
                {children}
            </div>
            <OutOfTheBox informationFilter={informationFilter} />
            <img className="f-modalCapacidades__forma" src={forma1} alt="forma" />

        </div>
    )
}

export default ModalCapacidades